export default class Strings {
  public static swungDashEscape(v: string) {
    if (!v) {
      return ''
    }
    return v.replaceAll('~', '')
  }

  public static swungDashSplit(v: string) {
    const res: string[] = []
    if (!v) {
      return res
    }
    for (const slice of v.split('~~')) {
      let chunks = slice.trim().split('~')
      for (let i = 0; i < chunks.length - 1; i++) {
        const chunk = chunks[i]
        res.push(`${chunk}-`)
      }
      res.push(chunks[chunks.length - 1])
    }
    return res
  }

  public static formatLabel(str: string, maxwidth: number) {
    var sections: string[] = []
    var words = str.split(' ')
    var temp = ''

    words.forEach(function(item, index) {
      if (temp.length > 0) {
        var concat = temp + ' ' + item

        if (concat.length > maxwidth) {
          sections.push(temp)
          temp = ''
        } else {
          if (index == words.length - 1) {
            sections.push(concat)
            return
          } else {
            temp = concat
            return
          }
        }
      }

      if (index == words.length - 1) {
        sections.push(item)
        return
      }

      if (item.length < maxwidth) {
        temp = item
      } else {
        sections.push(item)
      }
    })

    return sections
  }
}
